/**
 * The melody editor's shortcuts, as the shortcut help lists them (melody toolkit M2; spec §10). The letters
 * work while the roll has focus; Alt+← / → while a chord in the lane has focus. The user approved the copy
 * on 2026-10-24; the ghost-option rows ([ / ], Enter, and Esc's new wording) are melody toolkit M4, approved by Brian
 * on the user's delegation on 2026-10-29.
 */
export const melodyShortcuts = [
  { key: 'Space', description: 'Play or stop' },
  { key: 'L', description: 'Loop on or off' },
  { key: 'C', description: 'Chords on or off' },
  { key: 'M', description: 'Melody on or off' },
  { key: 'R', description: 'Sing an idea' },
  { key: 'Shift+← / →', description: 'Select the next or previous note too' },
  { key: 'Alt+← / →', description: 'Move the end of a note, or of a chord, by a step' },
  { key: '[ / ]', description: 'Previous or next option' },
  { key: 'Enter', description: 'Keep the option' },
  { key: 'Esc', description: 'Discard the option, or leave the roll' },
] as const
